import { FormFieldWidget, ModelFieldType, SPI, ViewType } from '@kunlun/dependencies';
import EnhancedTimeDatePicker from './EnhancedTimeDatePicker.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.DateTime,
    widget: 'EnhancedTimeDatePicker',
    multi: false
  })
)
export class FormDatetimeEnhancedTimeDatePickerFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(EnhancedTimeDatePicker);
    return this;
  }
}